import { validateDateOfBirth } from '../helper/Validations';
import moment from 'moment';

const haveRequiredFields = tempRequiredFields => {
  // Find the dateOfBirth field
  const dateOfBirthField = tempRequiredFields.find(x => x.field === 'dateOfBirth');
  
  // Convert ISO date to DD/MM/YYYY format for validation if needed
  let dateOfBirthValue = dateOfBirthField?.value;
  if (dateOfBirthValue && moment(dateOfBirthValue, moment.ISO_8601, true).isValid()) {
    dateOfBirthValue = moment(dateOfBirthValue).format('DD/MM/YYYY');
  }
  
  return (
    tempRequiredFields.find(x => x.field === 'gender' && x.value !== '')
    && tempRequiredFields.find(x => x.field === 'maritalStatus' && x.value !== '')
    && dateOfBirthField && validateDateOfBirth(dateOfBirthValue)
  );
};

export default haveRequiredFields;
